import backend from '@common/backend';

import { gradeFromBE } from './grades';

const BASE = '/gradebooks';

export const clientGradeBooksFromBE = ({ grades, ...gradeBook }: any) => ({
	...gradeBook,
	grades: grades.map(gradeFromBE),
});

export const getClientGradeBooks = async (query: any) =>
	backend
		.get(`${BASE}/`, {
			params: query,
		})
		.then((gradeBooks) => gradeBooks.map(clientGradeBooksFromBE));
